<template>
  <div v-if="video">
    <!-- video selectionnée -->
    <div class="d-flex flex-row flex-wrap mx-2">
      <div class="p-2 col-xl-8 col-lg-8 col-md-12 col-sm-12">
        <VideoItem :video="video" :nextVideo="nextVideo"></VideoItem>
      </div>
      <div class="p-2 col-xl-4 col-lg-4 col-md-12 col-sm-12">
        <!-- autres videos du theme selectionné -->
        <h6 v-if="theme">
          <!-- {{ theme.videos.length }} vidéo<span v-if="theme.videos.length > 1">s</span>
          contenue<span v-if="theme.videos.length > 1">s</span> dans le thème
          {{ theme.title }} -->
          {{ $tc("theme.title", theme.videos.length, { param: theme.title }) }}
        </h6>
        <v-row v-if="theme">
          <v-col style="height: 575px" class="col overflow-y-auto">
            <VideoCard
              v-for="v in theme.videos"
              :key="v.id"
              :video="v"
              :theme="theme"
              :router-link-to="{
                name: 'videoFromTheme',
                params: { id: v.id, idTheme: theme.id },
              }"
              layout="horizontal"
              :active="v.id === video.id"
            ></VideoCard>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import VideoItem from "@/components/video/videoItem";
import VideoCard from "@/components/video/videoCard";

export default {
  name: "videoFromTheme",
  components: {
    VideoItem,
    VideoCard,
  },
  data: () => ({
    theme: null,
    videoId: null,
    video: null,
    videos: null,
    nextVideo: null,
    previousVideo: null,
  }),
  mounted() {
    this.refreshVideoDetail();
  },
  methods: {
    refreshVideoDetail() {
      const videoId = this.$route.params.id;
      const themeId = this.$route.params.idTheme;

      Api.get(`/videos/${videoId}`)
        .then((video) => {
          //.then est appelé lorsque la requete s'est bien passé.
          this.video = video.data; //On rempli le tableau initialement vide par ce qu'on a récupéré
          Api.get(`/themes/${themeId}`).then((theme) => {
            this.theme = theme.data;
            this.$store.dispatch(SET_BREADCRUMB, [
              { title: "Themes", route: "bibliothequeThemes" },
              { title: this.theme.title },
              { title: this.video.title },
            ]);
            this.getThemeNextVideo();
            this.getThemePreviousVideo();
          });
        })
        .catch((error) => {
          //console.log(error);
          return error;
        });
    },
    setThemeVideoRoute(video){
      if(video){
        video.route = {
          name: 'videoFromTheme',
          params: { id: video.id, idTheme: this.theme.id },
        }
      }
      return null;
    },
    getThemeNextVideo() {
      let currentVideoIndex = this.theme.videos.findIndex(
        (themeVideo) => themeVideo["@id"] == this.video["@id"]
      );
      if ((currentVideoIndex + 1) > 0 && this.theme.videos.length >= (currentVideoIndex + 1)) {
        this.nextVideo = this.theme.videos[currentVideoIndex + 1];
        this.nextVideo.theme = this.theme;
        this.setThemeVideoRoute(this.nextVideo);
      }
    },
    getThemePreviousVideo() {
      var currentVideoIndex = this.theme.videos.findIndex(
        (themeVideo) => themeVideo["@id"] == this.video["@id"]
      );
      if ((currentVideoIndex - 1) >= 0 && this.theme.videos.length >= (currentVideoIndex - 1) ) {
        this.previousVideo = this.theme.videos[currentVideoIndex - 1];
        this.setThemeVideoRoute(this.previousVideo);
      }
    },
  },
};
</script>
